import {Icon} from '@bitstillery/common/components/portal'
import {MithrilComponent} from '@bitstillery/mithril'
import {format_money_responsive} from '@bitstillery/common/lib/format'
import {watch} from '@bitstillery/mithril'
import type {Unwatch} from '@bitstillery/mithril'
import {$t} from '@bitstillery/common/app'
import m from '@bitstillery/mithril'

import {ProgressPromotion} from './progress'

import {$s} from '@/app'

export class IncentivePromotion extends MithrilComponent {
    watchers: Unwatch[] = []

    override onbeforeremove(vnode: m.VnodeDOM) {
        return new Promise(function (resolve) {
            vnode.dom.addEventListener('animationend', resolve)
        })
    }

    override oncreate(vnode: m.VnodeDOM) {
        // Initialize signal by accessing property first
        void $s.promotion.tokens_draft
        const tokensDraftSignal = $s.promotion.$tokens_draft
        this.watchers.push(
            watch(tokensDraftSignal, () => {
                vnode.dom.classList.add('tokens-changed')
                setTimeout(() => {
                    vnode.dom.classList.remove('tokens-changed')
                }, 3000)
            }),
        )
    }

    override onremove() {
        this.watchers.map((watcher) => watcher())
    }

    view(_vn: m.Vnode) {
        return (
            <div className='c-incentive promotion'>
                <a className='incentive-header' href='/my-portal/promotions'>
                    <Icon
                        name={$s.promotion.token_icon}
                        size='l'
                        tip={() =>
                            $t('promotions.eligible_multiple', {
                                token_value: format_money_responsive(
                                    $s.promotion.token_value,
                                    undefined,
                                    $s.identity.user.currency,
                                ),
                                turnover_draft: format_money_responsive(
                                    $s.promotion.turnover_draft,
                                    undefined,
                                    $s.identity.user.currency,
                                ),
                                turnover_redeemable: format_money_responsive(
                                    $s.promotion.turnover_redeemable,
                                    undefined,
                                    $s.identity.user.currency,
                                ),
                            })
                        }
                        type='unset'
                    />
                    {$s.promotion.type === 'multi-order' && (
                        <span className='progress-invoiced'>
                            <span className='redeemable'>{$s.promotion.tokens_redeemable}</span>
                            <span className='preview'>({$s.promotion.tokens_draft - $s.promotion.tokens_redeemable})</span>
                        </span>
                    )}
                </a>

                <div className='text'>
                    <ProgressPromotion extended={false} />
                </div>
            </div>
        )
    }
}
